var render, staticRenderFns
import script from "./ListController.vue?vue&type=script&lang=js&"
export * from "./ListController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d802ee3c",
  null
  
)

export default component.exports